import {
  MultiImageDownloadRepository,
  MultiImageDownloadService,
  SearchService
} from '@aipb/gulliver/catalog/data-access';
import { SearchTab } from '@aipb/gulliver/catalog/model';
import { CatalogGoogleAnalyticsService } from '@aipb/gulliver/util-google-analytics';
import { ConfirmDialogService } from '@aipb/shared/dialog';

import { Component, Input, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoService } from '@jsverse/transloco';
import { ResultTabItemComponent } from '../result-tab-item/result-tab-item.component';
import { ResultTabLabelComponent } from '../result-tab-label/result-tab-label.component';
import { ResultToolbarComponent } from '../result-toolbar/result-toolbar.component';
import { CatalogPermissionService } from '@aipb/gulliver/catalog/auth';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cat-result-tab-group',
  templateUrl: './result-tab-group.component.html',
  styleUrls: ['./result-tab-group.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTabsModule, ResultTabLabelComponent, ResultTabItemComponent, ResultToolbarComponent]
})
export class ResultTabGroupComponent implements OnInit {
  @Input() items: SearchTab[] = [];
  @Input() activeTabIndex: number;
  @Input() isMobile: boolean;

  multiImageDownloadActive$ = this.multiImageDownloadRepository.active$;

  constructor(
    private searchService: SearchService,
    private catalogGa: CatalogGoogleAnalyticsService,
    private confirmDialog: ConfirmDialogService,
    private transloco: TranslocoService,
    private multiImageDownloadService: MultiImageDownloadService,
    private multiImageDownloadRepository: MultiImageDownloadRepository,
    private catalogPermission: CatalogPermissionService
  ) {}

  ngOnInit(): void {
    if (this.items.length === 1) {
      this.searchService.setActiveTabIndex(0);
    }
  }

  onSelectedIndexChange(i: number): void {
    this.searchService.setActiveTabIndex(i);
  }

  onRemove(searchTab: SearchTab): void {
    this.searchService.remove(searchTab.id);
  }

  onClearAll(): void {
    this.confirmDialog
      .open$({
        title: this.transloco.translate('catalog.results_delete_confirm.title'),
        content: this.transloco.translate('catalog.results_delete_confirm.message')
      })
      .subscribe((confirmed) => {
        if (!confirmed) return;

        this.searchService.removeAll();
        this.catalogGa.SEARCH_RESULTS.clear();
      });
  }

  get hasDownloadBatchRole(): boolean {
    return this.catalogPermission.hasDownloadBatchRole;
  }

  onToggleMultiImageDownload(): void {
    this.multiImageDownloadService.toggleActive();
  }

  customTB(index: number, tab: SearchTab) {
    return tab.id;
  }
}
